var basketOverlay = {

	preInit: function () {
		// get template
		var template = $('#basketOverlayTemplate').html();
		template = Hogan.compile(template);

		// add template
		$('.l-usp-bar').after(template.render());

		basketOverlay.allow = true;

		var p = $('#popupBasketOverlay');
		if (!p.length) return;

		// close
		p.find('.js-close').off('click').on('click', function () {
			p.hide();
			return false;
		});

		// init
		var sticky = new Waypoint.Sticky({
			element: p[0]
		});
	},

	update: function (message) {
		var e = $('#popupBasketOverlay').find('.js-message');
		if (!e.length) return;
		// update message
		e.html(message);
		// pulse if already visible
		if (e.is(':visible')) {
			e.addClass('pulse');
		}
		// clear pulse after ends
		e.one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function () {
			e.removeClass('pulse');
		});
		// show overlay
		basketOverlay.show();
	},

	show: function () {
		$('#popupBasketOverlay').show();
	},

	hide: function () {
		$('#popupBasketOverlay').hide();
	}

};

$(function () {
	basketOverlay.preInit();
});